module.exports = __webpack_public_path__ + "static/media/cap3-leg-desk.2a72c140.png";